import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  OnUpdateUserRequest,
  OnUpdateUserResponse,
  UserID,
  UsersResult,
} from "../interfaces/user.types.ts";
import { getExceptionMessage } from "../../exceptions/helpers/getExceptionMessage.ts";
import { userExceptions } from "../../exceptions/default/userExceptions.ts";
import api from "../../api";

export const fetchAllUsers = createAsyncThunk(
  "users/fetchAllUsers",
  async (url: string, thunkAPI) => {
    try {
      const response = await api.get<UsersResult>(url);
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        userExceptions.fetchAllUsers,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const fetchUserByID = createAsyncThunk(
  "users/fetchUserByID",
  async (id: string, thunkAPI) => {
    try {
      const response = await api.get<UserID>(`/accounts/users/${id}/`);
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        userExceptions.fetchUserByID,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (user: OnUpdateUserRequest, thunkAPI) => {
    try {
      const response = await api.patch<OnUpdateUserResponse>(
        `/accounts/users/${user.id}/update`,
        user,
      );
      return {
        id: user.id,
        ...response.data,
      };
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        userExceptions.updateUser,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);
